var ALLOWED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
var MAX_IMAGE_SIZE_BYTES = 10 * 1024 * 1024;
export function validateImageFile(file) {
    if (!ALLOWED_IMAGE_MIME_TYPES.includes(file.type)) {
        return file.name + " \u306F\u5BFE\u5FDC\u3057\u3066\u3044\u306A\u3044\u30D5\u30A1\u30A4\u30EB\u5F62\u5F0F\u3067\u3059\uFF08jpg/png/gif/webp \u306E\u307F\uFF09";
    }
    if (file.size > MAX_IMAGE_SIZE_BYTES) {
        return file.name + " \u306E\u30D5\u30A1\u30A4\u30EB\u30B5\u30A4\u30BA\u304C 10MB \u3092\u8D85\u3048\u3066\u3044\u307E\u3059";
    }
    return null;
}
